import { render } from "./SingleChoiceQuestion.vue?vue&type=template&id=3f7d92b9"
import script from "./SingleChoiceQuestion.vue?vue&type=script&lang=js"
export * from "./SingleChoiceQuestion.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__